import React, { Component } from "react";
import styled from "styled-components";

import { Close as CloseIcon } from "@material-ui/icons";

import { app } from "js/namespaces";

import { AnimationEditor } from "./Components/AnimationEditor/AnimationEditor";
import { AudioPanel } from "./Components/AudioPanel/AudioPanel";
import { SlideOptionsPanel } from "./Components/SlideOptionsPanel";

const TabType = {
    EDITOR: "editor",
    AUDIO: "audio",
    SLIDE_OPTIONS: "slideOptions"
};

const Container = styled.div`
    display: block;
    width: 100%;
    height: 100%;
`;

const HeaderContainer = styled.div`
    background: #333333;
    height: 40px;
    box-shadow: rgb(0 0 0 / 40%) 0 0 11px 0px;
    display: flex;
    flex-flow: row;
    justify-content: flex-start;
    align-items: center;
`;

const Header = styled.div`
    color: #ffffff;
    text-transform: uppercase;
    font-size: 14px;
    font-weight: 600;
    margin-left: 33px;
`;

const TabsContainer = styled.div`
    display: flex;
    flex-flow: row;
    justify-content: space-between;
    align-items: center;
    margin-left: 120px;
    height: 100%;
`;

const TabButton = styled.div.attrs(({ selected }) => ({
    style: {
        background: selected ? "#ffffff" : "#333",
        color: selected ? "#11a9e2" : "#ffffff"
    }
}))`
    display: flex;
    align-items: center;
    justify-content: center;
    text-transform: uppercase;
    font-size: 13px;
    font-weight: 600;
    padding: 0 25px 0 25px;
    height: 100%;
    cursor: pointer;
    white-space: nowrap;

    &:hover {
        opacity: 0.9;
    }
`;

const CloseButtonContainer = styled.div`
    width: 100%;
    display: flex;
    flex-flow: row;
    justify-content: flex-end;
    align-items: center;
`;

const CloseButton = styled(CloseIcon)`
    color: #ccc;
    margin-right: 6px;
    cursor: pointer;

    &:hover {
        color: #11a9e2;
    }
`;

const ContentContainer = styled.div`
    margin: 25px 30px 0 30px;
    width: calc(100% - 60px);
    height: calc(100% - 85px);
`;

export class AnimationPanel extends Component {
    constructor() {
        super();

        this.state = {
            currentTab: app.animationPanelTab ?? TabType.EDITOR
        };
    }

    onTabSelected(tabType) {
        this.setState({ currentTab: tabType });

        app.animationPanelTab = tabType;
    }

    render() {
        const { canvas, isReadOnly, dialogHeight, onClose } = this.props;
        const { currentTab } = this.state;

        return (
            <Container>
                <HeaderContainer>
                    <Header>Animation</Header>
                    <TabsContainer>
                        <TabButton
                            selected={currentTab === TabType.EDITOR}
                            onClick={() => this.onTabSelected(TabType.EDITOR)}
                        >
                            Build
                        </TabButton>
                        <TabButton
                            selected={currentTab === TabType.AUDIO}
                            onClick={() => this.onTabSelected(TabType.AUDIO)}
                        >
                            Audio
                        </TabButton>
                        <TabButton
                            selected={currentTab === TabType.SLIDE_OPTIONS}
                            onClick={() => this.onTabSelected(TabType.SLIDE_OPTIONS)}
                        >
                            Slide options
                        </TabButton>
                    </TabsContainer>
                    <CloseButtonContainer>
                        <CloseButton onClick={onClose} />
                    </CloseButtonContainer>
                </HeaderContainer>
                <ContentContainer>
                    {currentTab === TabType.EDITOR && <AnimationEditor canvas={canvas} isReadOnly={isReadOnly} dialogHeight={dialogHeight} />}
                    {currentTab === TabType.AUDIO && <AudioPanel canvas={canvas} isReadOnly={isReadOnly} dialogHeight={dialogHeight} />}
                    {currentTab === TabType.SLIDE_OPTIONS && <SlideOptionsPanel canvas={canvas} isReadOnly={isReadOnly} dialogHeight={dialogHeight} />}
                </ContentContainer>
            </Container>
        );
    }
}
